import {
  ArrowLeftRight,
  BarChartIcon,
  ChartColumnIncreasing,
  ClipboardList,
  Globe,
  Home,
  Megaphone,
  PieChart,
  Settings,
  Unplug,
  UserCog,
  Users,
  Wallet,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { useModuleStatus } from "@/features/integrations/api/useModuleStatus";
import { useSegmentTourPromo } from "@/features/segments/tour/useSegmentTourPromo";
import { SidebarItem } from "@/types/sidebar/SidebarProps";
function useAdminSidebarRoutes() {
  const { t } = useTranslation();
  const { clientId } = useParams();
  const { data: appliesStatus } = useModuleStatus("applies", { clientId });
  const showApplies = appliesStatus?.enabled ?? false;
  const { data: webAnalyticsStatus } = useModuleStatus("web-analytics", { clientId });
  const showWebAnalytics = webAnalyticsStatus?.enabled ?? false;
  const { showHomeCard } = useSegmentTourPromo();

  // Get current year and month for budget planning
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1;
  const topRoutes: SidebarItem[] = [
    {
      label: t("routes.client.home"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.home}`,
      icon: Home,
    },
    {
      label: t("routes.client.campaigns"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.campaigns}`,
      icon: Megaphone,
    },
    {
      label: t("routes.client.segments"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.segments}`,
      icon: PieChart,
      beacon: showHomeCard ? t("admin.segments.tour.menuBeacon.description") : undefined,
    },
    {
      label: t("routes.client.vacancies"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.vacancies}`,
      icon: Users,
    },
    ...(showApplies
      ? [
        {
          label: t("common.applies"),
          path: `/${ROUTES.clients}/${clientId}/${ROUTES.applies}`,
          icon: ClipboardList,
        },
      ]
      : []),
    {
      label: t("routes.client.budgetPlanning"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.budgetPlanning}/${year}/${month}`,
      icon: Wallet,
    },
    {
      label: t("routes.client.transactions"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.transactions}`,
      icon: ArrowLeftRight,
    },
    {
      label: t("routes.client.users"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.users}`,
      icon: UserCog,
    },
    {
      label: t("routes.client.insights"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.insights}`,
      icon: BarChartIcon,
    },
    {
      label: t("integrations.modules.names.reporting", "Reporting"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.reporting}`,
      icon: ChartColumnIncreasing,
    },
    ...(showWebAnalytics
      ? [
        {
          label: t("webAnalytics.title"),
          path: `/${ROUTES.clients}/${clientId}/${ROUTES.webAnalytics}`,
          icon: Globe,
        },
      ]
      : []),
    {
      label: t("routes.client.integrations"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.integrations}`,
      icon: Unplug,
    },
  ];

  const bottomRoutes: SidebarItem[] = [
    {
      label: t("common.clientSettings"),
      path: `/${ROUTES.clients}/${clientId}/${ROUTES.edit}`,
      icon: Settings,
    },
  ];

  return { topRoutes, bottomRoutes };
}

export default useAdminSidebarRoutes;
